export default {
  title: 'Anträge auf Datenlöschung',
  fields: {
    created_at: 'Beantragt am',
    restaurant: 'Restaurant',
    customer: 'Kunde',
    note: 'Notiz',
    status: 'Status',
    completed_by: 'Abgeschlossen von',
    actions: 'Aktionen',
  },
  statuses: {
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
  },
  buttons: {
    approve: 'Genehmigen',
  },
  modals: {
    approve: {
      title: 'Datenlöschung für {{name}} genehmigen?',
      description:
        'Damit werden die personenbezogenen Daten des Kunden endgültig gelöscht und können nicht wiederhergestellt werden. Der Antrag wird als abgeschlossen markiert.',
    },
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_approve: 'Antrag konnte nicht genehmigt werden',
    approved: 'Antrag genehmigt und Daten gelöscht',
  },
};
